import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { AxiosRequestConfig } from 'axios';
import { RefObject, useEffect, useRef, useState } from 'react';
import api from '../../api/apiInstance';
import { useAppDispatch } from '../../store/hooks';
import { addNotification, NotificationType } from '../../store/features/notificationsSlice';
import closeIcon from '../../assets/images/close.svg';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined';
import StarOutlinedIcon from '@mui/icons-material/StarOutlined';
import { ImportExport } from '@mui/icons-material';
import { deletePictureFile, updateProductPictureOrder } from '../../api/requests/pictures';

interface ImageFileUploadCardProps {
    maxFilesAmount: number;
    handleFilesChanged: (pictures: PictureElement[]) => void;
    pictureFiles?: PictureElement[]
}

export interface FileUploadResponse {
    id: number;
    url?: string;
    key: string;
}

export interface PictureElement {
    inx: number;
    url: string;
    fileId: number;
    isMain: boolean;
}

export const ImageFileUploadCard: React.FC<ImageFileUploadCardProps> = ({ maxFilesAmount, handleFilesChanged, pictureFiles }) => {

    const uploadElem = useRef<HTMLInputElement>(null);
    const dispatch = useAppDispatch();

    const [mainImage, setMainImage] = useState("");

    const [imageUrls, setImageUrls] = useState([
        "https://m.media-amazon.com/images/I/71WOSLyBdXL._AC_SL1500_.jpg",
        "https://noqq.energy/wp-content/uploads/2024/06/ulemine-4.png",
        "https://noqq.energy/wp-content/uploads/2024/06/alumine-4.png",
        "https://noqq.energy/wp-content/uploads/2024/09/cooper-and-hunter-supreme-continental-uleval.webp",
    ]);

    const [imageElements, setImageElements] = useState<PictureElement[]>([
        // {inx: 0, isMain: true, url: "https://m.media-amazon.com/images/I/71WOSLyBdXL._AC_SL1500_.jpg", fileId: 1},
        // {inx: 1, isMain: false, url: "https://noqq.energy/wp-content/uploads/2024/06/ulemine-4.png", fileId: 2},
        // {inx: 2, isMain: false, url: "https://noqq.energy/wp-content/uploads/2024/06/alumine-4.png", fileId: 3},
        // {inx: 3, isMain: false, url: "https://noqq.energy/wp-content/uploads/2024/09/cooper-and-hunter-supreme-continental-uleval.webp", fileId: 4}
    ])

    useEffect(() => {
        if (pictureFiles?.length) {
            setImageElements([...pictureFiles])
        } else {
            setImageElements([])
        }

        console.log("aaa");
    }, [pictureFiles])

    const removeUrlFromList = (urlToRemove: string) => {
        const updatedUrls = imageUrls.filter((url) => url !== urlToRemove);
    
        setImageUrls(updatedUrls);
    
        // Check if the removed URL matches the mainImage
        if (mainImage === urlToRemove) {
            setMainImage("");
        }
    };

    const removeElementFromList = async (inx: number) => {
        try {
            if (imageElements.length <= 1) {
                return;
            }
    
            let delElement: any;
            for (const imgEl of imageElements) {
                if (imgEl.inx === inx) {
                    delElement = imgEl;
                }
            }
            await deletePictureFile(delElement!.fileId);
    
            const updatedElements = imageElements.filter((img) => img.inx !== inx);
            if (delElement?.isMain) {
                updatedElements[0].isMain = true;
                for (const imgEl of updatedElements) {
                    const res = await updateProductPictureOrder({fileId: imgEl.fileId, orderNr: imgEl.isMain ? 0 : 1})
                }
            }
    
            handleFilesChanged(updatedElements);
            setImageElements([...updatedElements]);
            dispatch(addNotification({ message: "Pilt eemaldatud edukalt", type: NotificationType.SUCCESS }))
        } catch {
            dispatch(addNotification({ message: "Pildi eemaldamine ebaõnnestus", type: NotificationType.ERROR }))
        }
    }

    const handleUpdateMainElement = async (inx: number) => {
        const prevElements = [...imageElements];
        prevElements.forEach((img) => {
            if (img.inx === inx) {
                img.isMain = true
            } else {
                img.isMain = false
            }
        })


        for (const imgEl of prevElements) {
            const res = await updateProductPictureOrder({fileId: imgEl.fileId, orderNr: imgEl.isMain ? 0 : 1})
        }

        setImageElements([...prevElements]);
    }

    const handleUploadAreaClick = () => {
        if (uploadElem.current) {
            uploadElem.current.click();
        }
    }

    const handleStartFileUpload = async (files: FileList | null) => {
        if (files === null || files?.item(0) === null) {
            return;
        }
        const config: AxiosRequestConfig = {
            onUploadProgress: progressEvent => {
                var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total!);
                console.log("FILE PROGRESS, ", percentCompleted)
            },
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }

        var data = new FormData();
        data.append('file', files[0]);
        data.append("orderNr", imageElements.length.toString());

        try {
            const res = await api.post<FileUploadResponse>(process.env.REACT_APP_RENTIC_API_URL! + "/files/upload_picture", data, config);
            const newElements = [{inx: imageElements.length, isMain: false, fileId: res.data.id, url: res.data.url!}, ...imageElements]
            setImageElements([...newElements]);
            handleFilesChanged(newElements);
            dispatch(addNotification({ message: "Pilt edukalt lisatud", type: NotificationType.SUCCESS }))
        } catch (e) {
            dispatch(addNotification({ message: "Pildi üleslaadimine ebaõnnestus", type: NotificationType.ERROR }))
        }
    }

    return (

        <div className="flex flex-col w-full snap-mandatory snap-x gap-4 items-baseline">


            {imageUrls.length < maxFilesAmount ?
                <div onClick={handleUploadAreaClick} className={`relative overflow-hidden cursor-pointer lg:min-w-[200px] min-w-[150px] h-[150px] aspect-square lg:w-[200px] lg:h-[200px] rounded-xl shadow-main flex justify-center snap-always snap-start p-3 cursor-pointer" onClick={() => handleUploadAreaClick()`}>


                    <div className="w-[150px] lg:w-[200px] h-full flex items-center flex-col justify-center border-dashed border border-black rounded-lg">
                        <div>
                            <FileUploadOutlinedIcon style={{ width: "30px", height: "30px" }} className='font-light' />
                        </div>
                        <div className='mt-1 max-w-[100px] text-center'>
                            Lae pilt üles või lohista siia
                            <input type="file" id="Lae fail" name="filename" placeholder='Lae fail üles' className='hidden' ref={uploadElem} onChange={(e) => { handleStartFileUpload(e.target.files); e.target.files = null; }} />
                        </div>
                    </div>
                </div>
                : ""}


            {imageElements.length ?
            <div className={` ${maxFilesAmount > 1 ? "overflow-x-scroll" : "h-[200px]"} h-[150px] flex flex-row w-full gap-3 snap-mandatory snap-x`}>
            {/* TODO: check also if imageUrls isnt empty (once backend file uploading logic is ready) */}
            {/* {imageUrls.map((url) => {
                return (
                    <div className='relative group snap-always snap-start rounded-xl aspect-square'>
                        <img className="aspect-square w-full h-full" src={url} />
                        <div onClick={() => { removeUrlFromList(url) }} className="flex cursor-pointer group-hover:opacity-100 opacity-0 bg-primary absolute top-4 left-4 w-8 h-8 justify-center items-center transition-all duration-300 rounded-xl">
                            <img src={closeIcon} alt="" className={`w-[16px]`} />
                        </div>
                        <div onClick={() => { setMainImage(url) }} className={`${mainImage === url ? "opacity-100" : ""} flex cursor-pointer group-hover:opacity-100 opacity-0 bg-primary text-white absolute top-4 right-4 w-8 h-8 justify-center items-center transition-all duration-300 rounded-xl`}>
                            {mainImage === url ?

                                <StarOutlinedIcon />
                                : <StarBorderOutlinedIcon />}
                        </div>
                    </div>
                );
            })} */}
            {imageElements.map((itm, inx: number) => {
                return (
                    <div className='relative group snap-always snap-start rounded-xl aspect-square'>
                        <img className="aspect-square w-full h-full object-contain" src={itm.url} />
                        <div onClick={() => { removeElementFromList(inx) }} className="flex cursor-pointer group-hover:opacity-100 opacity-0 bg-primary absolute top-4 left-4 w-8 h-8 justify-center items-center transition-all duration-300 rounded-xl">
                            <img src={closeIcon} alt="" className={`w-[16px]`} />
                        </div>
                        <div onClick={() => { handleUpdateMainElement(inx) }} className={`${itm.isMain ? "opacity-100" : ""} flex cursor-pointer group-hover:opacity-100 opacity-0 bg-primary text-white absolute top-4 right-4 w-8 h-8 justify-center items-center transition-all duration-300 rounded-xl`}>
                            {itm.isMain ?

                                <StarOutlinedIcon />
                                : <StarBorderOutlinedIcon />}
                        </div>
                    </div>
                );
            })}
            </div>
            :
            <></>
            }
        </div>
    )
}